import { render, staticRenderFns } from "./AppEditButtons.vue?vue&type=template&id=3697167c&"
import script from "./AppEditButtons.vue?vue&type=script&lang=js&"
export * from "./AppEditButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports